import React from 'react';
import { PageLayout } from '@components/common/PageLayout';
import { HeadContent } from '@fourthwall/components';
import { EditPodcastModal } from '../EditPodcastModal';
import { PodcastSkeleton } from './PodcastSkeleton';
import { ExistingFields } from './components/ExistingFields/ExistingFields';
import { Header } from './components/Header/Header';
import { NewFields } from './components/NewFields/NewFields';
import { NoPostsFields } from './components/NoPostsFields/NoPostsFields';
import { usePodcastContext } from './hooks/usePodcastContext';
import { PodcastProvider } from './providers/PodcastProvider';
export const PodcastContent = () => {
    const { podcast, hasAnyAudioPost, isLoading, isEditModalOpen, handleUpdatePodcast, setIsEditModalOpen, handleRemovePodcast, } = usePodcastContext();
    if (!podcast || hasAnyAudioPost === undefined) {
        return React.createElement(PodcastSkeleton, null);
    }
    const getFields = () => {
        if (!hasAnyAudioPost)
            return React.createElement(NoPostsFields, null);
        return podcast.createdFromUrl ? React.createElement(ExistingFields, null) : React.createElement(NewFields, null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: podcast.name }),
        isEditModalOpen && (React.createElement(EditPodcastModal, { title: podcast.name, description: podcast.description, authorName: podcast.creatorName, contactEmail: podcast.creatorEmail, artworkUrl: podcast.imageUrl, category: podcast.category, subcategory: podcast.subcategory, loading: isLoading, onSubmit: (values, newImageResourceId) => handleUpdatePodcast(values, newImageResourceId), onClose: () => setIsEditModalOpen(false) })),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Header, { title: podcast.name, description: podcast.description, onEdit: () => {
                    setIsEditModalOpen(true);
                }, onRemove: handleRemovePodcast }),
            getFields())));
};
export const Podcast = () => (React.createElement(PodcastProvider, null,
    React.createElement(PodcastContent, null)));
